<template>
  <img :src="imageUrl" />
</template>
<script>
import { isEmpty } from 'lodash'
export default {
  name: 'SimpleImage',
  props: {
    id: String
  },
  computed: {
    imageUrl: function () {
      var url = null
      if (!isEmpty(this.id)) {
        url = `${this.$store.getters.getApiBasePath}/file/${this.id}`
      }
      return url
    }
  }
}
</script>
